module.exports = __webpack_public_path__ + "static/media/chopin-footer-4-en.524a13fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin-footer-4-en.svg
// module id = 629
// module chunks = 0